import { Fragment, useEffect } from "react";
import { useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";

const Cursor = () => {
  const [mouse, setMouse] = useState({
    x: 0,
    y: 0,
  });
  useEffect(() => {
    const mouseMove = (e) => {
      setMouse({
        x: e.clientX,
        y: e.clientY,
      });
    };

    window.addEventListener("mousemove", mouseMove);

    return () => {
      window.removeEventListener("mousemove", mouseMove);
    };
  }, []);

  return (
    <Fragment>
      <div
        style={{ left: `${mouse.x}px`, top: `${mouse.y}px` }}
        className="cursor"
        onClick={(e) => {
          e.stopPropagation();
        }}
      ></div>
       <button type="button" className="cursor_array" id="arrowLeft"
       style={{ left: `${mouse.x}px`, top: `${mouse.y}px` }}
      >
        <GoArrowLeft />
      </button>
      <button type="button" className="cursor_array" id="arrowRight"
       style={{ left: `${mouse.x}px`, top: `${mouse.y}px` }}
      >
        <GoArrowRight />
      </button>
     
    </Fragment>
  );
};

export default Cursor;
